/**
 * @generated SignedSource<<abf6ebbe7d30c868048fcda3b026f838>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type desktopRecorderApiCanEventBeLocallyRecordedQuery$variables = {
  eventId: string;
};
export type desktopRecorderApiCanEventBeLocallyRecordedQuery$data = {
  readonly event: {
    readonly canBeLocallyRecorded?: boolean;
  } | null;
};
export type desktopRecorderApiCanEventBeLocallyRecordedQuery = {
  response: desktopRecorderApiCanEventBeLocallyRecordedQuery$data;
  variables: desktopRecorderApiCanEventBeLocallyRecordedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "eventId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "eventId"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canBeLocallyRecorded",
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "desktopRecorderApiCanEventBeLocallyRecordedQuery",
    "selections": [
      {
        "alias": "event",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "desktopRecorderApiCanEventBeLocallyRecordedQuery",
    "selections": [
      {
        "alias": "event",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "066bf6f04066d6739091bc6723d00c9b",
    "id": null,
    "metadata": {},
    "name": "desktopRecorderApiCanEventBeLocallyRecordedQuery",
    "operationKind": "query",
    "text": "query desktopRecorderApiCanEventBeLocallyRecordedQuery(\n  $eventId: ID!\n) {\n  event: node(id: $eventId) {\n    __typename\n    ... on Event {\n      canBeLocallyRecorded\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d792de209251091316a85ecf26db02b7";

export default node;
